module.exports = __webpack_public_path__ + "img/mail.449c1be0.svg";